import { useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import { useSEO } from '@/hooks/useSEO';
import { siteInfo } from '@/mocks/site';
import HeroLive from './components/HeroLive';
import LiveFeed from './components/LiveFeed';
import CategoryGrid from './components/CategoryGrid';
import FeaturedTopics from './components/FeaturedTopics';
import VoiceSection from './components/VoiceSection';
import FaqPreview from './components/FaqPreview';
import CtaBand from './components/CtaBand';

export default function Home() {
  const jsonLd = useMemo(() => {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteInfo.name,
        url: origin,
        description: siteInfo.description,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${origin}/topics?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteInfo.name,
        email: siteInfo.email,
        description: '以话题观察方式整理娱乐热点与网络讨论的中文资讯站点。',
        foundingDate: siteInfo.since,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: `${siteInfo.name} - ${siteInfo.slogan}`,
        description: siteInfo.description,
        inLanguage: 'zh-CN',
      },
    ];
  }, []);

  useSEO({
    title: `${siteInfo.name} - 首屏新内容实时上新 | 最新动态与轮播更新抢先看`,
    description:
      '黑料首页首屏区保持高频刷新，最新动态、轮播更新、新内容持续上架。蹲新瓜、追后续，第一时间看到刚出炉的爆料与实锤，不错过任何一条新鲜猛料。',
    keywords: '黑料首页,黑料首页最新,黑料首页动态,黑料首页上新,娱乐热点,网络热议',
    canonicalPath: '/',
    jsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar brandAsH1 />
      <main>
        <HeroLive />
        <LiveFeed />
        <CategoryGrid />
        <FeaturedTopics />
        <VoiceSection />
        <FaqPreview />
        <CtaBand />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}